import { render } from "./emailsettings.vue?vue&type=template&id=7f712992"
import script from "./emailsettings.vue?vue&type=script&lang=js"
export * from "./emailsettings.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-POP-PROD\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__